import { useEffect, useRef, useState } from 'react';
import { Dialog, IconButton, useBreakpoint } from 'ui';
import { Search } from 'ui/icons';

import { OmnisearchAutocomplete } from '../OmnisearchAutocomplete/OmnisearchAutocomplete';

export const Omnisearch = () => {
  const { isMobile } = useBreakpoint();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const autocompleteRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isDialogOpen) {
      setTimeout(() => {
        autocompleteRef.current?.querySelector('input')?.focus(); // autoFocus doesn't seem to work when the input is inside a dialog
      }, 100);
    }
  }, [isDialogOpen]);

  useEffect(() => {
    const focusSearchOnKeypress = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        if (isMobile) {
          setIsDialogOpen(true);
        }
        autocompleteRef.current?.querySelector('input')?.focus();
      }
    };

    document.addEventListener('keydown', focusSearchOnKeypress);

    return () => {
      document.removeEventListener('keydown', focusSearchOnKeypress);
    };
  }, [isMobile]);

  const handleOptionSelect = () => {
    if (isMobile) {
      setIsDialogOpen(false);
    }
  };

  if (isMobile) {
    return (
      <>
        <IconButton onClick={() => setIsDialogOpen(true)} size="large">
          <Search />
        </IconButton>
        <Dialog
          open={isDialogOpen}
          onClose={() => {
            setIsDialogOpen(false);
          }}
          fullWidth
          PaperProps={{
            sx: {
              position: 'fixed',
              top: '10%',
            },
          }}
        >
          <OmnisearchAutocomplete onOptionSelect={handleOptionSelect} autocompleteRef={autocompleteRef} />
        </Dialog>
      </>
    );
  }

  return <OmnisearchAutocomplete onOptionSelect={handleOptionSelect} autocompleteRef={autocompleteRef} />;
};
